import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import HttpHelper from '../service/httpService'
import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'

const InquiryFormData = (props) => {

    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, getValues, clearErrors } = useForm({});
    const [businessPhone, setBusinessPhone] = useState()
    const submitInquiryform = async (data, event) => {
        await HttpHelper.post("Website/PartnerContactInquiry", data).then((response) => {
            if (response.status === 200) {
                setBusinessPhone("");
                event.target.reset();
                props.showToast("success", "Your inquiry submited succesfully, We will get back to you shortly.");
            }
        }).catch((error) => {
            console.log(error);
        })
    }

    return (<>
        <section className="section blackBg">
            <div className="container">
                {/*<div className="col-md-12 text-center">*/}
                {/*    <h4>Please fill the following details.</h4>*/}
                {/*</div>*/}
                <form className="row NewFormReDesign form-group" onSubmit={handleSubmit(submitInquiryform)}>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">First Name : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize" {...register("firstName", { required: true })} />
                                {errors.firstName?.type === 'required' && <p className="text-danger" role="alert">First name is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">Last Name : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize" {...register("lastName", { required: true })} />
                                {errors.lastName?.type === 'required' && <p className="text-danger" role="alert">Last Name is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">Title : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize" {...register("titile", { required: true })} />
                                {errors.titile?.type === 'required' && <p className="text-danger" role="alert">Titile is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">Company Name : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize" {...register("companyName", { required: true })} />
                                {errors.companyName?.type === 'required' && <p className="text-danger" role="alert">Company Name is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">Street Address : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize" {...register("StreetName", { required: true })} />
                                {errors.StreetName?.type === 'required' && <p className="text-danger" role="alert">StreetAddress is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">City : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize" {...register("cityName", { required: true })} />
                                {errors.cityName?.type === 'required' && <p className="text-danger" role="alert">City is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">State : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize" {...register("state", { required: true })} />
                                {errors.state?.type === 'required' && <p className="text-danger" role="alert">State is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">Postal code : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize" {...register("postalCode", { required: true })} />
                                {errors.postalCode?.type === 'required' && <p className="text-danger" role="alert">Postal Code is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">Country : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize" {...register("CountryName", { required: true })} />
                                {errors.CountryName?.type === 'required' && <p className="text-danger" role="alert">Country is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">Email Address : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize" {...register("EmailAddress", { required: true, pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i })} />
                                {errors.EmailAddress?.type === 'required' && <p className="text-danger" role="alert">Email is required</p>}
                                {errors.EmailAddress?.type === 'pattern' && <p className="text-danger" role="alert">Email is not valid</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">Business Phone : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="hidden" className="form-control labelInputSize" {...register("businessPhone", { required: true })} />
                                <PhoneInput
                                    defaultCountry="US"
                                    className="inputPhoneNumber"
                                    placeholder="Enter phone number"
                                    value={businessPhone}
                                    onChange={(e) => { setBusinessPhone(e); setValue('businessPhone', e); }}
                                    error={businessPhone ? (isValidPhoneNumber(businessPhone) ? undefined : 'Invalid phone number') : 'Phone number required'}
                                />
                                {errors.businessPhone?.type === 'required' && <p className="text-danger" role="alert">Business Phone is required</p>}
                                {errors.businessPhone?.type === 'number' && <p className="text-danger" role="alert">Business Phone is not valid</p>}
                                {businessPhone ? (isValidPhoneNumber(businessPhone) ? undefined : <p className="text-danger" role="alert">Invalid phone number</p>) : null}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">Company Website : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize" {...register("companyWebsite", { required: true })} />
                                {errors.companyWebsite?.type === 'required' && <p className="text-danger" role="alert">Company Website is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">Partnership Timeframe : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize" {...register("partnershipTimeframe", { required: true })} />
                                {errors.partnershipTimeframe?.type === 'required' && <p className="text-danger" role="alert">Partnership Time frame is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">Size of Business : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize"{...register("sizeOfBusiness", { required: true })} />
                                {errors.sizeOfBusiness?.type === 'required' && <p className="text-danger" role="alert">Size of business is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">Socio-Economic Group : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize" {...register("socioEcoGroup", { required: true })} />
                                {errors.socioEcoGroup?.type === 'required' && <p className="text-danger" role="alert">Socio Eco Group is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-3 col-12 col-form-label labelStart labelFontSize">Primary NAICS code : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-9 col-12">
                                <input type="text" className="form-control labelInputSize" {...register("PrimaryNaicsCode", { required: true })} />
                                {errors.PrimaryNaicsCode?.type === 'required' && <p className="text-danger" role="alert">NAICS Code is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-12 col-12 col-form-label labelStart labelFontSize">Describe the nature of your business : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-12 col-12">
                                <textarea  {...register("natureOfBusiness", { required: true })}></textarea>
                                {errors.natureOfBusiness?.type === 'required' && <p className="text-danger" role="alert">Nature of Business name is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-12 mb-2">
                        <div className="form-group row">
                            <label className="col-md-12 col-12 col-form-label labelStart labelFontSize">Provide a brief decription of your inquiry/idea : <span className="requiredAstric"> *</span></label>
                            <div className="col-md-12 col-12">
                                <textarea  {...register("descriptionOfIdea", { required: true })}></textarea>
                                {errors.descriptionOfIdea?.type === 'required' && <p className="text-danger" role="alert">Description is required</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-12 mb-2 mt-2">
                        <div className="form-group row d-flex justify-content-center">
                            <div className="col-md-3">
                                <center><button type="submit" style={{ width: "100%" }} className="btn btnTrailboss">Submit</button></center>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    </>)
}

export default InquiryFormData;